module.exports = __webpack_public_path__ + "img/cpu.dc3aa363.svg";